import React, { Component } from 'react'
import Slider from 'react-slick'
import './AccountRevenueMobile.sass'

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import CloseIcon from '@material-ui/icons/Close'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import Modal from '@material-ui/core/Modal'

import PropTypes from 'prop-types'

import { formatNoDecimalBigInt, formatDecimal } from '@atheneum/api/dist/lib'

class AccountRevenueMobile extends Component {
  static propTypes = {
    accounts: PropTypes.array,
    total: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
    this.calculateNextPrevious = this.calculateNextPrevious.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
    this.populateAndShowModal = this.populateAndShowModal.bind(this)

    this.state = {
      canGoNext: true,
      canGoPrevious: false,
      modalOpen: false,
      modalContent: {}
    }
  }

  populateAndShowModal (content) {
    this.setState({ modalContent: content })
    this.toggleModal()
  }

  toggleModal () {
    this.setState({ modalOpen: !this.state.modalOpen })
  }

  calculateNextPrevious (slide) {
    this.setState({
      canGoNext: !(
        slide >=
        this.props.accounts.length + 1 - this.slider.props.slidesToShow
      ),
      canGoPrevious: !(slide <= 0)
    })
  }
  next () {
    this.slider.slickNext()
  }

  previous () {
    this.slider.slickPrev()
  }

  render () {
    const settings = {
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1.2,
      slidesToScroll: 1,
      afterChange: this.calculateNextPrevious
    }

    if (this.props.accounts.length < 1) return null

    return (
      <div className='mobile-accountRevenue-slider-container'>
        <div className='mobile-accountRevenue-labels'>
          <div className='accountRevenue-table-cell-mobile'>Account Name</div>
          <div className='accountRevenue-table-cell-mobile'>ES Revenue €</div>
          <div className='accountRevenue-table-cell-mobile'>EBR Revenue €</div>
          <div className='accountRevenue-table-cell-mobile'>
            Survey Revenue €
          </div>
          <div className='accountRevenue-table-cell-mobile'>EP Revenue €</div>
        </div>
        <div className='mobile-accountRevenue-slider'>
          <Slider ref={c => (this.slider = c)} {...settings}>
            <div className='mobile-accountRevenue-slide'>
              <div className='accountRevenue-table-cell-mobile'>Total</div>
              <div className='accountRevenue-table-cell-mobile'>
                {formatDecimal(this.props.total.ES)}
              </div>
              <div className='accountRevenue-table-cell-mobile'>
                {formatDecimal(this.props.total.EBR)}
              </div>
              <div className='accountRevenue-table-cell-mobile'>
                {formatDecimal(this.props.total.ESR)}
              </div>
              <div className='accountRevenue-table-cell-mobile'>
                {formatDecimal(this.props.total.EP)}
              </div>
            </div>

            {this.props.accounts.map((account, index) => {
              return (
                <div
                  className='mobile-accountRevenue-slide'
                  key={index}
                  onClick={() => this.populateAndShowModal(account)}
                >
                  <div className='accountRevenue-table-cell-mobile accountRevenue-table-cell-mobile__name'>
                    {account.accountName}
                  </div>
                  <div className='accountRevenue-table-cell-mobile'>
                    {formatNoDecimalBigInt(account.ES)}
                  </div>
                  <div className='accountRevenue-table-cell-mobile'>
                    {formatNoDecimalBigInt(account.EBR)}
                  </div>
                  <div className='accountRevenue-table-cell-mobile'>
                    {formatNoDecimalBigInt(account.ESR)}
                  </div>
                  <div className='accountRevenue-table-cell-mobile'>
                    {formatNoDecimalBigInt(account.EP)}
                  </div>
                </div>
              )
            })}
          </Slider>
          <Modal open={this.state.modalOpen} onClose={() => this.toggleModal()} style={{overflowY: 'scroll'}}>
            <div className='dashboard-modal-container'>
              <div className='dashboard-modal-contents'>
                <CloseIcon
                  className='close-modal'
                  onClick={() => this.toggleModal()}
                />
                <div className='mobile-modal-container'>
                  <h2>Account Details</h2>
                  <div className='mobile-modal-item'>
                    <div className='mobile-modal-heading'>Account Name</div>
                    <div>{this.state.modalContent.accountName}</div>
                  </div>
                  <div className='mobile-modal-item'>
                    <div className='mobile-modal-heading'>ES Revenue €</div>
                    <div>
                      {formatNoDecimalBigInt(this.state.modalContent.ES)}
                    </div>
                  </div>
                  <div className='mobile-modal-item'>
                    <div className='mobile-modal-heading'>EBR Revenue €</div>
                    <div>
                      {formatNoDecimalBigInt(this.state.modalContent.EBR)}
                    </div>
                  </div>
                  <div className='mobile-modal-item'>
                    <div className='mobile-modal-heading'>Survey Revenue €</div>
                    <div>
                      {formatNoDecimalBigInt(this.state.modalContent.ESR)}
                    </div>
                  </div>
                  <div className='mobile-modal-item'>
                    <div className='mobile-modal-heading'>EP Revenue €</div>
                    <div>
                      {formatNoDecimalBigInt(this.state.modalContent.EP)}
                    </div>
                  </div>
                  {this.state.modalContent.offices?.map((office, index) => (
                    <div className='mobile-modal-item-separator'>
                      <div className='mobile-modal-item'>
                        <div className='mobile-modal-heading'>{index+1}. Office Name</div>
                        <div>{office.officeName}</div>
                      </div>
                      <div className='mobile-modal-item'>
                        <div className='mobile-modal-heading'>ES Revenue €</div>
                        <div>
                          {formatNoDecimalBigInt(office.ES)}
                        </div>
                      </div>
                      <div className='mobile-modal-item'>
                        <div className='mobile-modal-heading'>EBR Revenue €</div>
                        <div>
                          {formatNoDecimalBigInt(office.EBR)}
                        </div>
                      </div>
                      <div className='mobile-modal-item'>
                        <div className='mobile-modal-heading'>Survey Revenue €</div>
                        <div>
                          {formatNoDecimalBigInt(office.ESR)}
                        </div>
                      </div>
                      <div className='mobile-modal-item'>
                        <div className='mobile-modal-heading'>EP Revenue €</div>
                        <div>
                          {formatNoDecimalBigInt(office.EP)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Modal>
          <div className='slider-chevrons'>
            <button
              disabled={!this.state.canGoPrevious}
              onClick={this.previous}
            >
              <ChevronLeftIcon />
            </button>
            <button disabled={!this.state.canGoNext} onClick={this.next}>
              <ChevronRightIcon />
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default AccountRevenueMobile
